import * as React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../lib/utils';

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbsProps = React.ComponentPropsWithoutRef<'nav'> & {
  items: BreadcrumbItem[];
};

const Breadcrumbs = React.forwardRef<HTMLElement, BreadcrumbsProps>(
  ({ items, className, ...props }, ref) => (
    <nav ref={ref} aria-label="Breadcrumb" className={cn('', className)} {...props}>
      <ol className="flex items-center gap-1.5 type-body-sm text-muted-foreground">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <ChevronRight className="size-icon-xs shrink-0 text-muted-foreground/60" />
              )}
              {isLast || !item.href ? (
                <span
                  className={cn(isLast ? 'font-medium text-foreground' : 'text-muted-foreground')}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <a href={item.href} className="transition-colors hover:text-foreground">
                  {item.label}
                </a>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  ),
);
Breadcrumbs.displayName = 'Breadcrumbs';

export { Breadcrumbs };
export type { BreadcrumbItem, BreadcrumbsProps };
